import Vue from 'vue';

Vue.filter('filter_tags', function(value) {
    return value.replace(/<\/?[^>]+(>|$)/g, '');
});
